import { render, staticRenderFns } from "./multi-gradebook.vue?vue&type=template&id=18f0685e&shadow"
import script from "./multi-gradebook.vue?vue&type=script&lang=js&shadow"
export * from "./multi-gradebook.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&shadow&external")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./multi-gradebook.vue?vue&type=style&index=1&id=18f0685e&prod&lang=css&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports